import { FC, ReactElement } from 'react';
import { Box, Flex, Link, LinkProps } from '@chakra-ui/react';
export interface CbNavigationSubLinkProps extends LinkProps {
  hasBorderBottom?: boolean;
  isActive: boolean;
  isDisabled?: boolean;
  icon?: ReactElement;
  renderAsButton?: boolean;
}
export const CbNavigationSubLink: FC<CbNavigationSubLinkProps> = ({
  as,
  children,
  hasBorderBottom,
  href,
  isActive,
  isDisabled,
  icon,
  renderAsButton = false,
  onClick,
  ...props
}) => <Link as={renderAsButton ? 'button' : as} href={href ? href : undefined} aria-current={isActive ? 'page' : undefined} borderBottom={hasBorderBottom ? '1px solid' : ''} borderColor="cloud.300" color={isActive ? 'luigisPants.500' : 'cloud.800'} disabled={isDisabled} display="block" fontFamily="codenext" fontSize="sm" paddingX="22px" paddingY="18px" textAlign="left" width="100%" _hover={{
  backgroundColor: 'cloud.300',
  textDecoration: 'none'
}} _focus={{
  backgroundColor: 'cloud.300',
  textDecoration: 'none'
}} onClick={onClick} {...props} data-sentry-element="Link" data-sentry-component="CbNavigationSubLink" data-sentry-source-file="CbNavigationSubLink.tsx">
    <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CbNavigationSubLink.tsx">
      {icon && <Box marginRight={3} paddingBottom="2px">
          {icon}
        </Box>}
      {children}
    </Flex>
  </Link>;